<template>
    <div class="container">
        <h1>Sound level measuring instrument testo 815</h1>
            <div class="row">
                <div class="col-lg-6 col-md-6 cont1">
                    <h4>Measurement Range: <span>+32 to +130 dB </span></h4>
                    <h4>Measurement Accuracy: <span>±1.0 dB </span></h4>
                    <h4>Units: <span>dB </span></h4>
                </div>
                <div class="col-lg-5 col-md-5 cont2">
                    <img src="@/images/Instrument/sound/s1.jpg" alt="">
                </div>
            </div>
            
    </div>
</template>
<style lang="scss" scoped>
.container{
    margin:40px 20;
    padding: 30px 15px;
}
h1{
    text-transform: uppercase;
    color:#075daa;
    margin-bottom: 15px;
}
h4{
    color: red;
}
span{
    color: black;
}
@media (max-width: 767px) {
 .cont1:nth-of-type(1) {
    order: 2;
  }
  .cont2:nth-of-type(2) {
    order: 1;
  }
}

.cont2 img {
    width:100%;
    height: 100%;
}
h1{
    color:#075daa;
}
.row{
    border-bottom: 2px solid #075daa;
}
.cont2{
    padding-bottom: 10px;
}
@media (max-width: 281px) {
    h1{
        font-size:24px;
    }
    h4{
        font-size: 20px;
    }
    span{
        font-size: 18px;
    }
}
</style>